// /src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCeHWkYew4a1nqhNY2Wedi_QZE4p074geQ",
  authDomain: "apex-counseling-dashboard.firebaseapp.com",
  projectId: "apex-counseling-dashboard",
  storageBucket: "apex-counseling-dashboard.appspot.com",
  messagingSenderId: "124930041317",
  appId: "1:124930041317:web:be729728e8ade028bebb0c",
  measurementId: "G-FQ6DZEJE9C"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
